import React from 'react';
import StepCard from '../../common/StepCard/StepCard';
import styles from './Features.module.scss';

const Features = () => {
  const steps = [
    {
      stepNumber: 1,
      title: 'Download App & Complete KYC',
      description: '',
    },
    {
      stepNumber: 2,
      title: 'Create Mandate & Share with your Customer',
      description: '',
    },
    {
      stepNumber: 3,
      title: 'Get money settled in your Bank Account',
      description: '',
    },
  ];

  return (
    <section className={styles.features}>
      <div className={styles.content}>
        <div className={styles.contentHeading}>Your Roadmap to Effortless <span>Payment Collection</span></div>
        <p>
          Managing payments has never been easier – our platform automates your
          entire payment lifecycle in just 3 steps.
        </p>
      </div>
      <div className={styles.cards}>
        {steps.map((step, idx) => (
          <StepCard
            key={idx}
            stepNumber={step.stepNumber}
            title={step.title}
            description={step.description}
          />
        ))}
      </div>
    </section>
  );
};

export default Features;
